import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { TextButton, Heading } from '@wix/design-system';

import { Text } from '../../components/common';
import { Image } from '../../components/page/empty-page/image';
import { NAVIGATION } from '../../config';

import styles from './external-user.scss';
import noSignalImage from './no-signal.svg';

export const ExternalUserComponent = ({ intl }: WrappedComponentProps) => (
  <div data-hook="external-user">
    <div className={styles.content}>
      <Image iconSrc={noSignalImage} iconWithoutBackground width={80} />

      <div className={styles.title}>
        <Heading size="large">
          {intl.formatMessage({ id: 'layout.external.title' })}
        </Heading>
      </div>

      <div className={styles.description}>
        <Text weight="thin" size="medium">
          {intl.formatMessage({ id: 'layout.external.description.first' })}
        </Text>

        <span className={styles.descriptionLink}>
          <TextButton dataHook="wix-support-link">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={NAVIGATION.CONTACT_US_URL} target="_blank">
              {intl.formatMessage({ id: 'layout.external.description.link' })}
            </a>
          </TextButton>
        </span>

        <Text weight="thin" size="medium">
          {intl.formatMessage({ id: 'layout.external.description.second' })}
        </Text>
      </div>
    </div>
  </div>
);

export const ExternalUser = injectIntl(ExternalUserComponent);
